import { useTranslate } from "@similarweb/i18n-provider";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { DemoBadge } from "app/pages/sales-intelligence/common-components/badge/DemoBadge";
import { INDUSTRY_TAXONOMY_DEMO_ID } from "app/pages/sales-intelligence/modules/industry/constants";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";
import { useActiveDemoId } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";

/**
 * Header for the v2 industry taxonomy column. The badge is demo-only: an opted-in account owns this column
 * permanently, so labelling it DEMO would be wrong. The column's mere presence no longer implies a demo —
 * the backend also serves it for opted-in accounts, which send no `demoMode` marker.
 */
export const IndustryTaxonomyColumnHeader = () => {
    const { translate } = useTranslate();

    const isIndustryDemoActive = useActiveDemoId() === INDUSTRY_TAXONOMY_DEMO_ID;

    if (isIndustryDemoActive) {
        return (
            <Flex
                inline
                alignItems="center"
                gap="6px"
            >
                <Text fontVariant="captionTitle">{translate(leadsSearchFiltersI18nKeys.industryTaxonomyName())}</Text>
                <DemoBadge />
            </Flex>
        );
    }

    return translate(leadsSearchFiltersI18nKeys.industryTaxonomyName());
};
